import React, { ReactNode } from 'react';
import paddingDefault from './padding-default';
import Container from '../primitives/grid/container';
import { colors } from '../primitives/colors';

interface ErrorBoundaryProps {
    children: ReactNode;
}

interface ErrorBoundaryState {
    hasError: boolean;
    error?: Error;
}

class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
    constructor(props: ErrorBoundaryProps) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(error: Error): ErrorBoundaryState {
        return { hasError: true, error };
    }

    render(): JSX.Element|React.ReactNode|null {
        const { hasError, error } = this.state;
        const { children } = this.props;

        if (hasError) {
            if (process.env.NODE_ENV === 'development') {
                return (
                    <div css={[paddingDefault(), {
                        backgroundColor: colors.statesError,
                        color: colors.shadesWhite,
                    }]}
                    >
                        <Container>
                            <h1>Something went wrong:</h1>
                            <code>{error?.message}</code>
                        </Container>
                    </div>
                );
            }
            return null;
        }
        return children;
    }
}

export default ErrorBoundary;
